
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutor/volunteer-hours",
      function () {
        return require("private-next-pages/tutor/volunteer-hours.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutor/volunteer-hours"])
      });
    }
  